<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-watermark">
            <template #title v-if="id">
                <Банер>: <b>{{ data.name }} #{{ id }}</b> <br>
            </template>
            <template #title v-else>
                Нова Тема FAQ
            </template>
            <v-row class="pl-3 pr-3">
                <v-col cols="12" sm="6">
                    <ButtonComeBack />
                </v-col>

                <!--Зберегти: "механіка" + "опис-->
                <v-col cols="12" sm="6" class="text-right">
                    <v-btn color="primary" min-width="150" @click="update()">
                        Зберегти
                    </v-btn>
                </v-col>
            </v-row>

            <!-- {{ data }} -->
            <v-row>
                <v-col cols="12">
                    <v-form class="form-faq-theme-edit" lazy-validation v-model="isValidForm" ref="formfaqtheme">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-col cols="12" v-if="data.id">
                                    <v-text-field label="ID" v-model="data.id" readonly />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field label="Порядок" v-model="data.order" type="number"
                                        :rules="[v => true]" />
                                </v-col>
                                <v-col cols="12">
                                    <v-switch label="Активний" v-model="data.is_active" />
                                </v-col>


                                <!-- ----------------------------- ТАБИ локалізація ----------------------------- -->
                                <v-col cols="12">
                                    <v-tabs v-model="tab">
                                        <v-tab v-for="local in localization" :key="local.lang_key">
                                            {{ local.name }}
                                        </v-tab>
                                    </v-tabs>
                                </v-col>

                                <!--Содержимое табов-->
                                <v-col cols="12">
                                    <v-tabs-items v-model="tab">
                                        <v-tab-item v-for="(item, index) in data.langs" :key="item.lang_key"
                                            :eager="true">
                                            <template>
                                                <!-- Назва -->
                                                <v-text-field label="Назва" v-model="item.name" :rules="[v => true]" />
                                            </template>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-col>
                            </v-col>
                        </v-row>
                        <Preloader v-if="isSending" />
                        <DialogConfitmDelete ref="dialogConfirmDelete" />
                    </v-form>
                </v-col>
            </v-row>
        </material-card>
    </v-container>
</template>


<script>
import { HTTP } from '@/http-common';
import { some } from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';


export default {
    name: 'PageFaqThemesProfile',
    props: {
        id: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            enabled: false,
            data: {
                langs: [],
                is_active: true,
                order: null,
                id: null,
            },
            items: [],
            // Нужно vuetify для валидации формы
            isValidForm: true,
            // Сообщение об ошибке для обязательных полей
            errorRequired: `Це поле обов'язкове`,
            // Указывает на то что выполняется отправка формы
            isSending: false,
            tab: 0,
            itemsPerPage: 50,
            isLoading: false,
        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization', 'isManager', 'isAdmin']),
        someLangs() {
            return some(this.data.langs, (el) => el.name && el.name.length > 0);
        },
    },
    async mounted() {
        await this.init();
    },
    watch: {
    },
    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        async init() {
            await this.getLocalization();
            if (this.id) {
                await this.getdata();
            } else {
                this.data.langs = this.localization.map((el) => {
                    return {
                        lang_key: el.lang_key,
                        lang_name: el.name,
                        name: '',
                    };
                });
            }

        },
        async getdata() {
            let { data } = await HTTP.post('/get-faq-theme', { 'id': this.$route.params.id });
            this.data = data.content;
            return data.content;
        },
        async update() {
            let queryParams = this.data;

            if (this.isSending) return;
            if (!this.$refs.formfaqtheme.validate()) {
                this.setSnackbar({ type: 'error', text: 'Форма заповнена не вірно' });
                return;
            }
            if (!this.someLangs) {
                this.setSnackbar({ type: 'error', text: 'Заповніть будь ласка хоча б одну назву' });
                return;
            }

            this.isSending = true;

            try {
                await HTTP.post(this.data.id ? '/update-faq-theme' : '/create-faq-theme', queryParams);
                this.setSnackbar({
                    type: 'success',
                    text: `Данні оновлено.`
                });
                this.isSending = false;
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
                this.isSending = false;
            }
        },
    },
}
</script>

<style scoped lang="sass">
  .form-faq-theme-edit
    position: relative
  </style>
